/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface OnboardingDetailsDto {
    'onboardingStatus': OnboardingDetailsDtoOnboardingStatusEnum;
}

export const OnboardingDetailsDtoOnboardingStatusEnum = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
} as const;

export type OnboardingDetailsDtoOnboardingStatusEnum = typeof OnboardingDetailsDtoOnboardingStatusEnum[keyof typeof OnboardingDetailsDtoOnboardingStatusEnum];


